import { getApolloClientInternal } from "./apolloClient";

export function gc(): void {
    getApolloClientInternal().cache.gc();
}
